import { createSelector } from 'reselect';

const selectHeader = state => state.get('header');

export const selectMenuOpen = () =>
  createSelector(selectHeader, data => data.get('open'));
